/**
 * js文件中使用
 * import i18n from '@/i18n.js';
 * i18n.t('***',[])
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import storage from './models/storage'
import locales from './assets/locales'
Vue.use(VueI18n)

/* i18n config */
let lang = 'en'
    // if(['en', 'zh_cn', 'zh_tw'].indexOf(storage.get('lang')) > -1){
if (['zh_cn', 'zh_tw', 'en', 'ru', 'idn', 'jp', 'korea', 'vie'].indexOf(storage.get('lang')) > -1) {
    lang = storage.get('lang')
}
const i18n = new VueI18n({
    locale: lang,
    fallbackLocale: 'en',
    silentFallbackWarn: true,
    missing: (locale, key, vm, values) => {
        //  {{$t("key",  [""])}}
        if (values && values.length > 0) {
            if (values[0] == locale) {
                values = values.slice(1);
            }
            if (values && values.length > 0) {
                return values.toString();
            }
        }
        return key
    },
    messages: locales
})


import { Locale } from "vant";
import enUS from "vant/es/locale/lang/en-US";
import zhCN from "vant/es/locale/lang/zh-CN";
import zhHK from "vant/es/locale/lang/zh-HK";
import jP from "vant/es/locale/lang/ja-JP";
import rO from "vant/es/locale/lang/ro-RO";
// import kOR from "vant/es/locale/lang/kor-KOR";
// import iDN from "vant/es/locale/lang/idn-IDN";

const vantLocales = (lang) => {
    if (lang === 'en') {
        Locale.use(lang, enUS)
    } else if (lang === 'zh' || lang === 'zh_cn') {
        Locale.use(lang, zhHK)
    } else if (lang === 'jp') {
        Locale.use(lang, jP)
    } else if (lang === 'vie') {
        Locale.use(lang, rO)
    } else if (lang === 'korea') {
        Locale.use(lang, kOR)
    } else if (lang === 'idn') {
        Locale.use(lang, iDN)
    }
}

vantLocales(i18n.locale)
Vue.prototype.$vantLocales = vantLocales;

Vue.prototype.$locale = {
    change(language) {
        i18n.locale = language;
    },
    current() {
        return i18n.locale;
    }
};

export default i18n;


// WEBPACK FOOTER //
// ./src/i18n.js